
import { initializePaddle, Paddle } from '@paddle/paddle-js';
import { useEffect, useState } from 'react';

const Subscription = () => {
  // Create a local state to store Paddle instance
  const [paddle, setPaddle] = useState<Paddle>();

  /*
    // Create Paddle portal session
  useEffect(() => {
    const customerId = 'your_customer_id';
    fetch(`https://api.paddle.com/customers/${customerId}/portal-sessions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer your_api_token',
      },
      body: JSON.stringify({}),
    })
      .then(response => response.json())
      .then(data => setPortalSession(data))
      .catch(error => console.error(error));
  }, []);
  */
  // Download and initialize Paddle instance from CDN
  useEffect(() => {
    initializePaddle({
      environment: 'sandbox', token: 'test_bdcca88147affe867654b75bff1',
      eventCallback: function (data) {
        if (data.name == "checkout.completed") {
          console.log(data);
        }
      }

    }).then(
      (paddleInstance: Paddle | undefined) => {
        if (paddleInstance) {
          setPaddle(paddleInstance);
        }
      },
    );
  }, []);

  // Callback to open a checkout
  const openCheckout = () => {
    paddle?.Checkout.open({
      items: [{ priceId: 'pri_01jft6wjr75ss0qya1rhwkjz9g', quantity: 1 }],
    });
  };


  // Redirect to
  const openCustomerPortal = () => { 
    window.location.href = 'https://sandbox-customer-portal.paddle.com/cpl_01jft67r9az8dsnteps6rw5gyv';
  }

  const userData = {
    email: 'kamn.miller@gmail.com'
  }

  return (
    <div>
      <h1>Subscription</h1>
      {/* TODO: Better button */}
      <button onClick={openCheckout}>Subscribe</button>
      <button onClick={openCustomerPortal}>Manage Subscription</button>
    </div>
  )
}

export default Subscription